require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/modules/es7.symbol.async-iterator.js
// module id = 2x3v
// module chunks = 16